import { render, staticRenderFns } from "./DataTableWrapper.vue?vue&type=template&id=a77a368a&scoped=true"
import script from "./DataTableWrapper.vue?vue&type=script&lang=js"
export * from "./DataTableWrapper.vue?vue&type=script&lang=js"
import style0 from "./DataTableWrapper.vue?vue&type=style&index=0&id=a77a368a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a77a368a",
  null
  
)

export default component.exports